import axios from "axios";

export const report = axios.create({
  baseURL: document.querySelector("#reportPath").value,
  timeout: 5000,
  headers: {
    // 'X-Auth-Token': 'f2b6637ddf355a476918940289c0be016a4fe99e3b69c83d',
    "Content-Type": "application/json"
  }
});
